




























































import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { FieldComponent, FormFieldElement } from '@/types/FieldComponent';
import { findFieldComponent } from '@/utils/form';
import DynamicForm from '@/components/FormBuilder/DynamicForm.vue';
import LayoutMixin from '@/mixins/LayoutMixin';

@Component({
  components: {
    DynamicForm,
  },
})
export default class TabbedDynamicForm extends Mixins(LayoutMixin) {
  /**
   * Массив компонентов формы на основе схемы мутации graphQl
   */
  @Prop()
  readonly fieldComponents!: FieldComponent[]

  get formLayoutFieldComponents(): FormFieldElement[] {
    return this.formLayoutFields.map((layoutElement) => findFieldComponent(layoutElement, this.fieldComponents));
  }

  get isTabbedForm(): boolean {
    const nonPanelElement = this.formLayoutFieldComponents.find((formElement) => formElement.fieldComponent);
    return typeof nonPanelElement === 'undefined';
  }

  async submit(formData: Record<string, any>) {
    this.$emit('submit', formData);
  }
}
